import { type TPandasDataFrameDict } from '../components/TPandasDataFrameDict';
import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';
import { type ISortingMeta } from '../models/ISortingMeta';
import CoreJsonAPIService from './CoreJsonAPIService';

export class SvDownloadCenterServices extends CoreJsonAPIService {
  static async getDownloadLists(params: { page: number; sorting: ISortingMeta; search?: string }) {
    return await super.get<IAugmentedBackendResponse<TPandasDataFrameDict>>(EDjangoAppsEndpoints.downloadsCenter, '', {
      page: params.page,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending,
      searchText: params.search ?? ''
    });
  }

  static async downloadFile(params: { url: string; startDate?: number; endDate?: number }) {
    return await super.getFileResponse(EDjangoAppsEndpoints.factsheet, params.url, {
      startDate: params.startDate?.toString(),
      endDate: params.endDate?.toString()
    });
  }
}
